<template>                    
    <form-helper>
        <div slot="form-header">
            
            <h2 class="grey--text text--darken-2">Stammdaten</h2>                                                
            
        </div>
        
        <div slot="form-fields">
            <v-layout row>
                <v-layout column>
                    <v-flex xs6>
                        <v-text-field
                          name="name"
                          label="Name"
                          :error="errors.has('name')"
                          id="firmaname"
                          v-model="fa.name"
                          v-validate="'required|min:3'"
                        ></v-text-field>
                        <small class="small red--text" v-show="errors.has('name')">{{ errors.first('name') }}</small> 
                    </v-flex>
                    <v-flex xs6>
                        <v-text-field
                          name="namezusatz"
                          label="Namezusatz"
                          id="firmanamezusatz"
                          v-model="fa.namezusatz"
                        ></v-text-field>
                    </v-flex>
                                    
                    <v-flex xs6>
                        <v-text-field
                          name="telefon"
                          label="Telefon"
                          :error="errors.has('telefon')"
                          id="firmatelefon"
                          v-model="fa.telefon"
                          v-validate="'required'"
                        ></v-text-field>
                        <small class="small red--text" v-show="errors.has('telefon')">{{ errors.first('telefon') }}</small> 
                    </v-flex>
                    <v-flex xs6>
                        <v-text-field
                          name="fax"
                          label="Fax"
                          id="firmafax"
                          v-model="fa.fax"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout column>
                    <v-flex xs6>
                       <v-text-field
                         name="email"
                         label="eMail"
                         id="firmaemail"
                         :error="errors.has('email')"
                         v-model="fa.email"
                         v-validate="'required|email'"
                       ></v-text-field>
                        <small class="small red--text" v-show="errors.has('email')">{{ errors.first('email') }}</small> 
                   </v-flex>
                   <v-flex xs6>
                       <v-text-field
                         name="web"
                         label="Web"
                         id="firmaweb"
                         v-model="fa.web"
                       ></v-text-field>
                   </v-flex>
                    
                </v-layout>   
                     
            </v-layout>   
        </div>
        
        <div slot="form-commands" >

            <v-btn icon v-on:click="submitted">
                <v-icon x-large class="green--text">done</v-icon>
            </v-btn>                        


            <router-link to="/firmen" exact>
                <v-btn icon>
                    <v-icon x-large class="red--text">close</v-icon>
                </v-btn>
            </router-link>

        </div>
    </form-helper>



</template>

<script>
import formHelper from '../formHelper.vue'


export default {
    inject: ['$validator'],
    components: {
        'form-helper': formHelper
    },
    data() {
        return {
            fa: {},            
        };
    },
    computed: {
     
    },    
    methods: {
       submitted: function() {  
           this.$store.commit('setMessagebar', false)
           this.$validator.validateAll().then((result) =>{
               if(!result) {
                   this.$store.commit('setMessagebar', true)
                   return                   
               }
               this.$emit('submitted', this.fa)               
           })
           
        },
    }
}
    
</script>

<style>
    
    
    
</style>


// WEBPACK FOOTER //
// createFirmen_1.vue?7ce6360d